
import formats from '../../api/formats.js'

class Step {
  constructor (title, subTitle, props, model) {
    this.title = title
    this.subTitle = subTitle
    this.props = props
    this.model = model
    this.editable = false
  }
  addToArray (array) {
    array.push(this)
    this.number = array.length
  }
  setModel (model) {
    this.model = model
  }
  formatField (name) {
    var v = this.model[name]
    if (!v) {
      return ' - '
    }
    if (v instanceof Date) {
      return formats.formatDate(v)
    }
    return v.toString()
  }
  nextEnabled () {
    return true
  }
  nextLabel () {
    return 'Дальше'
  }
  backEnabled () {
    return true
  }
  backLabel () {
    return 'Назад'
  }
  next (model, nextFn) {
    return nextFn(model)
  }
  back (model, backFn) {
    return backFn(model)
  }
}

class Model {
  constructor () {
    this.currentStep = 1
    // step1
    this.companyInn = null
  }

  getCurrentStep () {
    return this.currentStep
  }

  setCurrentStep (val) {
    this.currentStep = val
  }

  getCompanyInn () {
    return this.companyInn
  }

  getDescription () {
    return ''
  }

  getDescription2 () {
    return ''
  }
}

class Strategy {
  constructor (cxt) {
    this.context = cxt
    this.steps = []
  }
  getSteps () {
    return this.steps
  }
  createModel () {
    return new Model()
  }
}

class Repository {
  get (key) {
    return new Promise((resolve, reject) => resolve(null))
  }
  update (key, item) {
    return new Promise((resolve, reject) => resolve(key))
  }
  delete (key) {
    return new Promise((resolve, reject) => resolve())
  }
}

class MapRepository extends Repository {
  constructor (keyCb, arr) {
    super()
    this.keyCb = keyCb
    this.items = new Map()
    this.setItems(arr)
  }
  setItems (arr) {
    let map = new Map()
    if (arr && Array.isArray(arr)) {
      for (const item of arr) {
        map.set(this.keyCb(item), item)
      }
    }
    this.items = map
  }
  getItems () {
    return Array.from(this.items.values())
  }
  // Repository overrides
  get (key) {
    return new Promise((resolve, reject) => resolve(this.items.get(key)))
  }
  update (key, item) {
    return new Promise((resolve, reject) => {
      let k = key || this.keyCb(item)
      this.items.set(k, item)
      resolve(k)
    })
  }
  delete (key) {
    return new Promise((resolve, reject) => {
      this.items.delete(key)
      resolve()
    })
  }
}

class SingleStepStrategy extends Strategy {
  constructor (cxt, typeCode) {
    super(cxt)
    this.repo = null
    this.typeCode = typeCode
  }
  setRepo (repo) {
    this.repo = repo
  }
  getTypeCode () {
    return this.typeCode
  }
  getTypeName () {
    return this.getTypeCode()
  }
  setContext (cxt) {
    this.context = cxt
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createDefaultModel () {
    return Object.assign(this.createModel(), {})
  }
  createModelFromData (data) {
    return Object.assign(this.createModel(), data)
  }
  updateSteps (scheme) {
    let steps = []
    new Step(
      '',
      (step) => {},
      {
        scheme: this.updateScheme()
      },
      {
      }).addToArray(steps)
    this.steps = steps
    return this
  }
  updateScheme (scheme) {
    return []
  }
  getModel () {
    let steps = this.getSteps()
    return steps && steps.length > 0 && steps[0].model
  }
  updateModel (model) {
    this.getSteps().forEach((step) => step.setModel(model))
  }
  fetchData (itemId) {
    return this.repo ? this.repo.get(itemId) : new Promise((resolve, reject) => resolve(null))
  }
  updateData (itemId, model) {
    return this.repo ? this.repo.update(itemId, model) : new Promise((resolve, reject) => resolve(itemId))
  }
  deleteData (itemId, model) {
    return this.repo ? this.repo.delete(itemId) : new Promise((resolve, reject) => resolve())
  }
  viewTitle (model) {
    return this.getTypeName()
  }
  viewTitleComp (model) {
    return formats.createComp(`<span>${this.viewTitle()}</span>`)
  }
  viewContent (model) {
    const _f = (v) => v || '-'
    if (!model) {
      return ''
    }
    let modelStr = ''
    for (const [key, value] of Object.entries(model)) {
      modelStr.concat(`${key}: ${_f(value)}\n`)
    }
    return `${modelStr}`
  }
  viewContentComp (model) {
    const _f = (v) => v || '-'
    if (!model) {
      return ''
    }
    let modelStr = ''
    for (const [key, value] of Object.entries(model)) {
      modelStr.concat(`<div>${key}: <b>${_f(value)}</b></div>`)
    }
    return formats.createComp(`
      <div>${modelStr}</div>
    `)
  }
}

export default {
  Step,
  Model,
  MapRepository,
  Strategy,
  SingleStepStrategy
}



// WEBPACK FOOTER //
// ./src/components/assist/AssistClasses.js